import Vue from 'vue'
import App from './App.vue'
import { router } from '@/router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
 
Vue.config.productionTip = false

store.dispatch('authStore/initAuth', null, { root: true })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app-recruitment')
